import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { StoresService } from '../../services/stores.service';
import { PaginationComponent } from '../../common/pagination/pagination.component';
import { MatDialog } from '@angular/material/dialog';
import { ImplantsModalComponent } from 'src/app/shared/implants-modal/implants-modal.component';
import { ImplantsEditComponent } from 'src/app/shared/implants-edit/implants-edit.component';
import { FormsModule } from '@angular/forms';
import { CabinetService } from '../../services/cabinet.service';
import { MarkConsumeModalComponent } from '../mark-consume-modal/mark-consume-modal.component';
import { ToastMessageComponent } from 'src/app/common/toast-message/toast-message.component';
import { ResetStatusModalComponent } from '../reset-status-modal/reset-status-modal.component';
import { ImpantsLowStockModalComponent } from 'src/app/shared/impants-low-stock-modal/impants-low-stock-modal.component';

@Component({
  selector: 'app-implants-list',
  standalone: true,
  imports: [CommonModule, PaginationComponent, FormsModule, RouterLink, ToastMessageComponent],
  templateUrl: './implants-list.component.html',
  styleUrls: ['./implants-list.component.scss', '../../../app.component.scss']
})
export class ImplantsListComponent implements OnInit{
  @ViewChild(PaginationComponent) paginationView: PaginationComponent;
  @ViewChild(ToastMessageComponent) toastMessage: ToastMessageComponent;

  public storeId = "";
  public storeDetails: any;

  public implantType = "";

  public implantProducts: any = [];
  public isImplantProducts: boolean = false;

  public cabinetNamesList: any = [];
  public selectedCabinetNames: any = [];
  public isCabinetNames: boolean = false;

  public totalPages: number = 0;
  public currentPage: number = 1;
  
  public totalImplants: number = 0;

  public searchInput: string = "";
  public encodedSearchInput: string = "";


  public isSearch = false;
  public isFilter = false;
  public isFilterResult = true;
  
  public expirySortValue:string = "";
  public orderBy:string = "asc";


  constructor(public storeService: StoresService, public cabinetService: CabinetService, public dialog: MatDialog, public location: Location, public route: ActivatedRoute){

  }

  ngOnInit(): void {

    this.route.params.subscribe(routeParams => {
      this.storeId = routeParams.id;
      this.implantType = routeParams.type;
      
      this.getStoreDetails();
      this.getImplants(); 
      this.getStoreCabinetNames();
      
    });

    // this.storeId = this.route.snapshot.params['id'];
    // this.implantType = this.route.snapshot.params['type'];
  }

  getImplants(page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []){
    this.storeService.getImplants(this.storeId, this.implantType, page, search, expiry, cabinets).subscribe(res => {
      if (res.data) {
        if (res.data.data.length !== 0) {
          this.totalImplants = res.data.total;
          this.totalPages = res.data.last_page;
          this.implantProducts = res.data.data;

          // Debug log for low stock implants
          if (this.implantType === 'low_stocks') {
            console.log('Low stock implants data:', this.implantProducts);
            console.log('Sample product:', this.implantProducts[0]);
          }

          if (this.isSearch || this.isFilter) {
            this.isFilterResult = true;
          }else{
            this.isImplantProducts = true;
          }
        }else{
          this.totalImplants = 0;
          this.totalPages = 0;
          if (this.isSearch || this.isFilter) {
            this.isFilterResult = false;
          }else{
            this.isImplantProducts = false;
          }
        }
      }
    });
  }

   downloadImpants(page: string = "", search: string = "", expiry: string = "", cabinets: Array<string> = []) {
      if (this.searchInput !== "") {
        this.isSearch = true;
        this.encodedSearchInput = encodeURIComponent(this.searchInput);
      }

      this.storeService.downloadImplants(this.storeId, this.implantType, page, this.encodedSearchInput || '', expiry, cabinets).subscribe((res) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(res);
        const now = new Date();
        const datetime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
        let store_name = this.storeDetails.name.toLowerCase().replace(/\s+/g, '_');
        link.download = `${this.implantType}_${store_name}_${datetime}.xlsx`;
        link.click();
      });
    }

  getStoreCabinetNames(){
    this.cabinetService.getCabinetNames(this.storeId, ['id', 'u_name']).subscribe((res)=>{
      if (res.data.length !== 0) {
        this.isCabinetNames = true;
        this.cabinetNamesList = res.data;
      }else{
        this.isCabinetNames = false;
      }
    });
  }
  getStoreDetails(){
    this.storeService.getStoreDetails(this.storeId).subscribe((res)=>{
      if (res.data) {
        this.storeDetails = res.data;
      }
    });
  }

  openDialog(storeId: string, implantId: string): void {
    const dialogRef = this.dialog.open(ImplantsModalComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openLowStockDialog(storeId:string,productId: string, ): void {
    const dialogRef = this.dialog.open(ImpantsLowStockModalComponent, {
      data: {
        storeId,
        productId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  openEditDialog(storeId: string, implantId: string): void {
    const dialogRef = this.dialog.open(ImplantsEditComponent, {
      data: {
        storeId,
        implantId
      }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  onSearchSubmit(){ 
    if (this.searchInput !== "") {
      this.isSearch = true; 
      if (this.isFilter) {
        this.expirySortValue = "";
        this.selectedCabinetNames = [];
        this.isFilter = false;
        this.isFilterResult = true; 
      }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getImplants("", this.encodedSearchInput);
    }
  }

  openCabinetsPopup(event){
    document.getElementById("cabinets-popup").classList.toggle("active");
    event.stopPropagation()
    this.closePopupOutside("cabinets-popup");
  }

  onCabinetFilterChange(event){
    if (event.target.checked) {
      this.selectedCabinetNames.push(event.target.value);
    }else{
      this.selectedCabinetNames = this.selectedCabinetNames.filter((element)=>{
        return element !== event.target.value;
      });
    }

    this.isFilter = true;
    this.onFilterChange();   
  }

  expirySort(){
    this.isFilter = true;

    if (this.expirySortValue === "asc") {
      this.expirySortValue = "desc";
    }else{
      this.expirySortValue = this.orderBy;
    }

    this.onFilterChange();   
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch || this.isFilter) {
      this.encodedSearchInput = "";
      this.expirySortValue = "";
      this.selectedCabinetNames = [];
      this.isSearch = false;
      this.isFilter = false;
      this.isFilterResult = true;
      if (this.currentPage > 1) {
        this.currentPage = 1;
        this.paginationView.onCurrentPageChange(this.currentPage);
      }
      this.getImplants("");
    }
  }

  onFilterChange(){
    if (this.currentPage > 1) {
      this.currentPage = 1;
      this.paginationView.onCurrentPageChange(this.currentPage);
    }
    
    this.getImplants("", this.encodedSearchInput, this.expirySortValue, this.selectedCabinetNames);
  }

  getQueryPage($event: number){
    this.currentPage = $event;    
    this.getImplants(`${this.currentPage}`, this.encodedSearchInput, this.expirySortValue, this.selectedCabinetNames);
  }

  goBack(){
    this.location.back();
  }

  openPopup(event){
    if (this.implantType !== 'expired') {
      let openedPopup = document.getElementsByClassName("dots-popup");
  
      let targetedElement = event.target.closest('td');
      let popupDiv = targetedElement.getElementsByClassName("dots-popup")[0];
  
      Array.from(openedPopup).forEach((el)=>{
        if (el !== popupDiv) {
          el.classList.remove('active');
        }
      })
  
      popupDiv.classList.toggle("active");
      event.stopPropagation();
  
      document.addEventListener('click', function(event: any) {
        if (
          popupDiv.className.includes("active") &&
          !popupDiv.contains(event.target)
        ) {
          popupDiv.classList.remove("active");
        }
      })  
    }
  }

  openConsumeDialog(storeId: string|number, implantId: string, implantName: string): void {
    const dialogRef = this.dialog.open(MarkConsumeModalComponent, {
      data: {
        storeId,
        implantId,
        implantName
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
          this.getImplants();
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }

  openResetStatusDialog(storeId: string|number, implantId: string, implantName: string): void {
    const dialogRef = this.dialog.open(ResetStatusModalComponent, {
      data: {
        storeId,
        implantId,
        implantName
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.status) {
          this.toastMessage.showToast(result.message, "success", 5000);
          this.getImplants();
        }else{
          this.toastMessage.showToast(result.message, "error", 5000);
        }
      }
    });
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
